<ng-container *ngIf="isEdit; else viewRecord">
  <div class="col-12 pb-2">
    <div class="row">
      <div class="col-6"></div>
      <div class="col-6">
        <button class="btn mt-1 btn-primary float-right" (click)="addLineItem()">
          <fa-icon [icon]="['fas', 'plus']"></fa-icon>
          <span class="pl-1">{{ 'add' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
  <table class="table table-bordered table-striped w-100">
    <thead>
      <tr>
        <th class="w-5"></th>
        <th class="w-20 fs-12">{{ 'skill' | translate }}</th>
        <th class="w-20 fs-12">{{ 'duration' | translate }}</th>
        <th class="w-55 fs-12">{{ 'note' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="arFormLineItems.length">
        <ng-container *ngFor="let lineItem of arFormLineItems; let i = index">
          <tr>
            <td class="w-5 text-center">
              <fa-icon
                class="text-danger pointer"
                (click)="removeLineItem(i)"
                [icon]="['fal', 'minus-circle']">
              </fa-icon>
            </td>
            <td>
              <ng-select
                ngDefaultControl
                [(ngModel)]="lineItem.skill_relate.value"
                (open)="lineItem.skill_relate.loadDataOnClick()"
                [items]="lineItem.skill_relate.source | async"
                [loading]="lineItem.skill_relate.loader"
                [typeahead]="lineItem.skill_relate.typehead"
                [ngModelOptions]="{standalone: true}"
                bindLabel="text"
                appendTo="body"
                (ngModelChange)="onChangeSkill(lineItem, i)"
              ></ng-select>
            </td>
            <td>
              <input-date
                [objForm]="lineItem.form"
                [objItem]="lineItem.metadata['expiry_date']"
                [strMode]="edit"
              ></input-date>
            </td>
            <td>
              <app-edit-field
                [item]="objMetadata['note']"
                [form]="lineItem.form"
              ></app-edit-field>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</ng-container>
<ng-template #viewRecord>
  <table class="table table-bordered table-striped w-100">
    <thead>
      <tr>
        <th class="w-20 fs-12">{{ 'skill' | translate }}</th>
        <th class="w-20 fs-12">{{ 'duration' | translate }}</th>
        <th class="w-60 fs-12">{{ 'note' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="arLineItems.length; else noRecord">
        <ng-container *ngFor="let lineItem of arLineItems">
          <tr>
            <td>
              {{ lineItem.skill_text }}
            </td>
            <td>
              {{ lineItem.expiry_date | date:'mediumDate' | placeholdWithString }}
            </td>
            <td>
              {{ lineItem.note | placeholdWithString }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <ng-template #noRecord>
        <tr>
          <td colspan="3" class="text-center">
            {{ 'no_record_found' | translate }}
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</ng-template>